import { css } from '@emotion/react'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { SEM_EQUIPE_ITEM } from 'components/form'
import { LeafletMap } from 'components/map/LeafletMap'
import { usePinosTerritorioQuery } from 'graphql/hooks.generated'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { emptyArrayOf } from 'util/array'

import { VisualizacaoTerritorialBuscaFormModel } from '../model'
import { MapaTerritorioFeedback } from './components/MapaTerritorioFeedback'
import { MapaViewSidebar } from './components/MapaViewSidebar'
import { PinoTerritorioModal } from './components/PinoTerritorioModal'
import { TerritorioPinoModel } from './model-territorioMapa'
import { toMapMarkers } from './utils-territorioMapa'

export function TerritorioMapasView() {
  const { imovelId } = useParams<{ imovelId?: string }>()
  const { acesso } = useAcessoLotacaoOrEstagio()

  const initialValues: VisualizacaoTerritorialBuscaFormModel = {
    unidadeSaude: acesso?.unidadeSaude,
    equipe: acesso?.equipe ?? SEM_EQUIPE_ITEM,
  }

  const [filter, setFilter] = useState<VisualizacaoTerritorialBuscaFormModel>(initialValues)

  const { data, loading: isLoading } = usePinosTerritorioQuery({
    variables: {
      input: {
        cnes: filter.unidadeSaude.cnes,
        ine: filter.equipe?.ine,
        microarea: filter.microareas,
      },
    },
  })

  const imoveis = data?.pinosTerritorio?.content ?? emptyArrayOf<TerritorioPinoModel>()
  const markers = useMemo(() => toMapMarkers(imoveis), [imoveis])
  const mapFeedback = data?.pinosTerritorio ? <MapaTerritorioFeedback pinosTerritorio={data.pinosTerritorio} /> : null

  const onSearchSubmit = (values: VisualizacaoTerritorialBuscaFormModel) => {
    setFilter(values)
  }

  return (
    <div css={styles.root}>
      <MapaViewSidebar onSearchSubmit={onSearchSubmit} searchInitialValues={initialValues} />
      <LeafletMap zoom={4} markers={markers} mapFeedback={mapFeedback} showLoading={isLoading} />
      {imovelId && <PinoTerritorioModal imovelId={imovelId} />}
    </div>
  )
}

const styles = {
  root: css`
    display: grid;
    grid-template-columns: auto 1fr;
  `,
}
